module.exports = __webpack_public_path__ + "media/exploded_and_closeup_fade.2b64cb9c.webm";